import { useEffect } from 'react'
import { authClient } from '../../../lib/auth-client'
import { queryClient } from '../../../api/query-client'

export const LogoutRoute = () => {
    useEffect(() => {
        const doLogout = async () => {
            await authClient.signOut()
            queryClient.clear()
            window.location.href = '/login'
        }
        doLogout()
    }, [])

    return null
}